const getConfig = () => {
  if (window.location.hostname === "localhost") {
    // TODO: change the question ids and template ids to your local ids
    return {
      api: "http://localhost:3000",
      clerkKey: "pk_test_ZGV2b3RlZC1sYWR5YnVnLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",
      prenupTemplateId: "01967d86-e207-7ad0-9c1d-b608cb0210b4",
      weddingDateQuestionId: "019721ba-d44d-7e31-8b67-f2a87d7e383d",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b", // point to staging live session track id for testing
      sentryDsn:
        "https://eba852d63fff2c6cc808442e5107a11e@o910650.ingest.us.sentry.io/4509707936727040",
      environment: "development",
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
    };
  }
  if (window.location.hostname === "staging.helloprenup.com") {
    // TODO: change the question ids and template ids to your local ids
    return {
      api: "https://api.staging.helloprenup.com",
      clerkKey: "pk_live_Y2xlcmsuc3RhZ2luZy5oZWxsb3ByZW51cC5jb20k",
      prenupTemplateId: "01999158-f1c9-7c52-82df-7c5734634623",
      weddingDateQuestionId: "01999159-508b-7531-a868-ba2d9cb7dabd",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b",
      sentryDsn:
        "https://5c3f457c0180140c7e5a8665150d3fde@o910650.ingest.us.sentry.io/4510077374431232",
      environment: "staging",
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
    };
  }
  if (window.location.hostname === "dev.helloprenup.com") {
    return {
      api: "https://iicbdan22d.execute-api.us-west-2.amazonaws.com",
      clerkKey: "pk_test_ZGV2b3RlZC1sYWR5YnVnLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",
      prenupTemplateId: "0198c393-066e-7f21-ac06-d3c635c30e6f",
      weddingDateQuestionId: "0198c39c-cdcc-7c52-a88b-77035f7aee34",
      googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
      liveSessionTrackId: "1e410e7f.baece29b", // point to staging live session track id for testing
      sentryDsn:
        "https://eba852d63fff2c6cc808442e5107a11e@o910650.ingest.us.sentry.io/4509707936727040",
      environment: "development",
      defaultStateFDVideo: "CA",
      intercomAppId: "seizs4ey",
    };
  }
  return {
    api: "https://api.helloprenup.com",
    clerkKey: "pk_live_Y2xlcmsuaGVsbG9wcmVudXAuY29tJA",
    prenupTemplateId: "01999ec1-488c-7d20-9d51-debc5fed5254",
    weddingDateQuestionId: "01999ec7-3f8f-7ab3-b2ba-59bbc33c4b03",
    googleMapsApiKey: "AIzaSyCraBV6TrjrynCfMgw7bCK7kfF9aBMTy_M&q",
    liveSessionTrackId: "1e410e7f.852d3c21",
    sentryDsn:
      "https://5c3f457c0180140c7e5a8665150d3fde@o910650.ingest.us.sentry.io/4510077374431232",
    environment: "production",
    defaultStateFDVideo: "CA",
    intercomAppId: "seizs4ey",
  };

  // TODO: Add staging and production ids
};

const config = getConfig();

// Impact config
declare global {
  interface Window {
    ire?: {
      (
        action: "identify",
        payload: {
          customerId?: string;
          customerEmail?: string;
          customProfileId?: string;
          [key: string]: unknown;
        },
      ): void;
      (
        action: "trackConversion",
        actionTrackerId: number | string,
        payload: {
          orderId: string;
          customProfileId?: string;
          customerId?: string;
          customerEmail?: string;
          customerStatus?: string;
          currencyCode?: string;
          orderPromoCode?: string;
          orderDiscount?: number;
          items?: {
            subTotal: number;
            category: string;
            sku: string;
            quantity: number;
            name?: string;
            subCategory?: string;
            totalDiscount?: number;
            totalRebate?: number;
          }[];
          [key: string]: unknown;
        },
        options?: {
          verifySiteDefinitionMatch?: boolean;
          [key: string]: unknown;
        },
      ): void;
    };
    _rwq: unknown[];
    rewardful?: (methodName: string, ...args: unknown[]) => void;
    Rewardful?: Rewardful;
  }
  interface Rewardful {
    referral: string | null;
  }
}

export default config;
